import React, { useState } from "react";
export const Context = React.createContext();
export const ContextProvider = ({ children }) => {
    const [personal, setPersonal] = useState([])
    const [mobiEmail, setMobiEmail] = useState('')
    return (
   
    <Context.Provider
      value={{personal, setPersonal, mobiEmail, setMobiEmail}}>
      {children}
    </Context.Provider>
  );
};